document.addEventListener('DOMContentLoaded', function() {

  // CSS FIX: Make action buttons always clickable above overlay link
  var style = document.createElement('style');
  style.textContent = `
    .grid-item__overlay-link {
      z-index: 1 !important;
    }
    .grid-product__actions {
      z-index: 10 !important;
      pointer-events: all !important;
    }
    .grid-product__actions button,
    .grid-product__actions a {
      position: relative;
      z-index: 11 !important;
      pointer-events: all !important;
    }
     [class*="ai-card-actions-"] {
      z-index: 10 !important;
      pointer-events: all !important;
    }
    [class*="ai-card-action-btn-"] {
      position: relative;
      z-index: 11 !important;
      pointer-events: all !important;
    }
    [class*="ai-product-image-wrapper-"] a,
    [class*="ai-product-card-"] > a {
      z-index: 1 !important;
    }
         [class*="ai-add-to-cart-btn-"] {
      display: none !important;
      margin: 0 !important;
      padding: 0 !important;
      height: 0 !important;
    }
    [class*="ai-product-info-"] {
      padding-bottom: 8px !important;
    }
    `;
  document.head.appendChild(style);

  // FIX: "+" quick add button → add to cart
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-quick-add-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId = btn.dataset.id;
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    }).then(function() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.cart-count, .cart__count, [data-cart-count]')
            .forEach(el => el.textContent = cart.item_count);
          btn.disabled = false;
        });
    }).catch(function() {
      btn.disabled = false;
    });
  });

  // FIX: Product Grid quick view popup
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[class*="ai-quick-view-"]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var modalId = btn.className.match(/ai-quick-view-(\S+)/);
    if (!modalId) return;
    var id = modalId[1];
    var modal = document.getElementById('ai-qv-modal-' + id);
    if (!modal) return;
    modal.querySelector('[class*="ai-qv-img-"]').src = btn.dataset.productImage || '';
    modal.querySelector('[class*="ai-qv-title-"]').textContent = btn.dataset.productTitle || '';
    modal.querySelector('[class*="ai-qv-price-"]').textContent = btn.dataset.productPrice || '';
    modal.querySelector('[class*="ai-qv-link-"]').href = btn.dataset.productUrl || '#';
    modal.style.display = 'flex';
  });

    // FIX: Product Grid "+" quick add
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[class*="ai-quick-add-"]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    var originalHTML = btn.innerHTML;
    btn.innerHTML = '✓';
    btn.classList.add('added');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    }).then(function() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.cart-count, .cart__count, [data-cart-count]')
            .forEach(el => el.textContent = cart.item_count);
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.classList.remove('added');
            btn.disabled = false;
          }, 1500);
        });
    }).catch(function() {
      btn.innerHTML = originalHTML;
      btn.classList.remove('added');
      btn.disabled = false;
    });
  }, true);


  // FIX: Close quick view modal
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('[class*="ai-qv-close-"]');
    if (closeBtn) {
      var modal = closeBtn.closest('[id*="ai-qv-modal-"]');
      if (modal) modal.style.display = 'none';
      return;
    }
    if (e.target.id && e.target.id.startsWith('ai-qv-modal-')) {
      e.target.style.display = 'none';
    }
  });

});
